/*eslint-disable*/
import api from './';

class TelegramApi {

    // POST: telegram/verify
    static verify(telegramData) {
        return api.axios.post('/telegram/verify', telegramData)
            .then((response) => {
                return response.data;
            });
    }
}

export default TelegramApi;
